import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ConnectedArrivalField, DepartureField } from './MobileFields';
import { SwapButtonMobile } from './Segment/SwapButton';
import { ConfigProp, ConfigPropDefault, EntryPoint, ProductManagerErrorProp } from '../../models';
import {
    getConfig,
    getOriginErrorSelector,
    getDestinationErrorSelector,
    getActiveProduct,
    isCurrentSearchPopulated
} from '../../redux/currentSearch/selectors';
import { Config, LocationUtils } from '../../utils';
import { ClickTrackDPArrival, ClickTrackDPDeparture } from '../HotelManager/SearchFormFieldsClickableWrapper';

const FlightsManagerLegMobile = ({ activeProduct, isCurrentSearchPopulated, index, originError, destinationError, config }) => {
    const isOneEntryPointEnabled = Config.get('isOneEntryPointEnabled');
    const shouldShowSwap = config?.swapButton.visible && !originError && !destinationError;
    const getLocationText = (location, direction) => {
        return LocationUtils.getFieldText(location, direction);
    };
    const ClickTrackDeparture = activeProduct === EntryPoint.DP ? ClickTrackDPDeparture : Fragment;
    const ClickTrackArrival = activeProduct === EntryPoint.DP ? ClickTrackDPArrival : Fragment;
    const showOneEntryPoint = isOneEntryPointEnabled && !isCurrentSearchPopulated;
    return (
        <>
            <ClickTrackDeparture>
                <DepartureField
                    activeProduct={activeProduct}
                    geoLocationEnabled={index === 0}
                />
            </ClickTrackDeparture>
            { shouldShowSwap && !showOneEntryPoint && (
                <SwapButtonMobile />
            )}
            <ClickTrackArrival>
                <ConnectedArrivalField
                    getLocationText={getLocationText}
                    icon={'plane-landing'}
                    isTopDestination
                />
            </ClickTrackArrival>
        </>
    );
};

FlightsManagerLegMobile.propTypes = {
    index: PropTypes.number.isRequired,
    originError: ProductManagerErrorProp,
    destinationError: ProductManagerErrorProp,
    config: ConfigProp.isRequired,
};

FlightsManagerLegMobile.defaultProps = {
    originError: null,
    destinationError: null,
    config: ConfigPropDefault,
};

const mapStateToPropsSelector = createStructuredSelector({
    activeProduct: getActiveProduct,
    isCurrentSearchPopulated: isCurrentSearchPopulated,
    originError: getOriginErrorSelector,
    destinationError: getDestinationErrorSelector,
    config: getConfig,
});

export const ConnectedFlightsManagerLegMobile = connect(mapStateToPropsSelector, {})(FlightsManagerLegMobile);
